import React, { Component } from 'react';

import '../report-page.component.css';

import { HorizontalBarGraph } from '../../../common/graph/bar-graph.component'
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';

const graphData = [
        { name: "Verizon Wireless US", value:39975.2},
        { name: "Verizon Wireless US", value:104091.91}
  ];

class topVendors extends Component {

    
    render() {        
        return (
            <div className="component-container">                 
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName="Top 5 Countries 1" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false}   />
                <HorizontalBarGraph data={graphData} fill="#0071cc" withMargin={true} />  

            </div>
        )
    }

}

export default topVendors;